import { useEffect } from 'react'
import { Platform, Vibration } from 'react-native'
import { useStore } from '../../../models'
import { playSound } from '../../../utils/audioService'

const playerActionTimeLeftSeconds = 5 * 1000

const isWeb = Platform.OS === 'web'
const ENABLE_VIBRATION = !isWeb

export const useVibration = () => {
  const {
    game: { isCardsVisibleOnShowDown, isMyTurn, playerActionTimeLeft: duration, isWalkthrough },
    permissions: { isSoundEnabled }
  } = useStore()

  useEffect(() => {
    let timeOut: NodeJS.Timeout
    if (!isWalkthrough && isMyTurn && isSoundEnabled) {
      if (duration < playerActionTimeLeftSeconds) {
        ENABLE_VIBRATION && Vibration.vibrate(1000)
        return
      }
      const fiveSecondsBeforeYourTurnEnds = duration - playerActionTimeLeftSeconds
      // @ts-expect-error
      timeOut = setTimeout(() => {
        ENABLE_VIBRATION && Vibration.vibrate(1000)
      }, fiveSecondsBeforeYourTurnEnds)
    }

    return () => {
      clearTimeout(timeOut)
    }
  }, [isMyTurn, duration, isWalkthrough, isSoundEnabled])

  useEffect(() => {
    try {
      if (!isWalkthrough && isMyTurn && !isCardsVisibleOnShowDown && isSoundEnabled) {
        ENABLE_VIBRATION && Vibration.vibrate(1000) // Device Will Vibrate for 1 seconds.
        playSound('yourTurn')
      }
    } catch (error) {
      console.error('Vibration', error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMyTurn, isWalkthrough, isSoundEnabled])
}
